import { createReducer, on } from "@ngrx/store";
import { updateState } from "@obg/ngx.global";

import { LeftMenuAction } from "./left-menu.action";
import { LeftMenuState } from "./left-menu.model";

const INITIAL_STATE: LeftMenuState = {
	isLeftMenuOpen: false,
};

export const leftMenuReducer = createReducer(
	INITIAL_STATE,
	on(LeftMenuAction.leftMenuOpen, (state) =>
		updateState(state, {
			isLeftMenuOpen: true,
		})
	),
	on(LeftMenuAction.leftMenuClose, (state) =>
		updateState(state, {
			isLeftMenuOpen: false,
		})
	)
);
